import { CircularProgress, IconButton, Tooltip } from "@material-ui/core";
import { Document, Page, Text, View } from "@react-pdf/renderer";
import React from "react";
import { DownloadButton, styles } from "./styles";

export default function DownloadPDFBtn({
  pillars,
  evaluation,
  isLoadingGrades,
}) {
  return (
    <>
      {isLoadingGrades ? (
        <CircularProgress size={20} />
      ) : (
        <DownloadButton
          document={<PDF evaluation={evaluation} pillars={pillars} />}
          fileName={`${evaluation.professional.login}-evaluation.pdf`}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Tooltip title="Download PDF">
            <IconButton size="small">
              <svg
                width="14"
                height="14"
                viewBox="0 0 200 200"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M168 144V152H180C183.183 152 186.235 153.264 188.485 155.515C190.736 157.765 192 160.817 192 164C192 167.183 190.736 170.235 188.485 172.485C186.235 174.736 183.183 176 180 176H168V188C168 191.183 166.736 194.235 164.485 196.485C162.235 198.736 159.183 200 156 200C152.817 200 149.765 198.736 147.515 196.485C145.264 194.235 144 191.183 144 188V132C144 128.817 145.264 125.765 147.515 123.515C149.765 121.264 152.817 120 156 120H188C191.183 120 194.235 121.264 196.485 123.515C198.736 125.765 200 128.817 200 132C200 135.183 198.736 138.235 196.485 140.485C194.235 142.736 191.183 144 188 144H168ZM60 152C60 160.487 56.6286 168.626 50.6274 174.627C44.6263 180.629 36.4869 184 28 184H24V188C24 191.183 22.7357 194.235 20.4853 196.485C18.2348 198.736 15.1826 200 12 200C8.8174 200 5.76515 198.736 3.51472 196.485C1.26428 194.235 6.70682e-08 191.183 0 188V132C0 128.817 1.26428 125.765 3.51472 123.515C5.76515 121.264 8.8174 120 12 120H28C36.4869 120 44.6263 123.371 50.6274 129.373C56.6286 135.374 60 143.513 60 152ZM36 152C36 149.878 35.1571 147.843 33.6569 146.343C32.1566 144.843 30.1217 144 28 144H24V160H28C30.1217 160 32.1566 159.157 33.6569 157.657C35.1571 156.157 36 154.122 36 152ZM136 160C136 170.609 131.786 180.783 124.284 188.284C116.783 195.786 106.609 200 96 200H80C76.8174 200 73.7652 198.736 71.5147 196.485C69.2643 194.235 68 191.183 68 188V132C68 128.817 69.2643 125.765 71.5147 123.515C73.7652 121.264 76.8174 120 80 120H96C106.609 120 116.783 124.214 124.284 131.716C131.786 139.217 136 149.391 136 160ZM112 160C112 155.757 110.314 151.687 107.314 148.686C104.313 145.686 100.243 144 96 144H92V176H96C100.243 176 104.313 174.314 107.314 171.314C110.314 168.313 112 164.243 112 160ZM4 88V20C4 14.6957 6.10714 9.60859 9.85786 5.85786C13.6086 2.10714 18.6957 0 24 0H120C121.577 7.35257e-05 123.139 0.310993 124.595 0.914982C126.052 1.51897 127.376 2.40418 128.49 3.52L184.49 59.52C186.737 61.7699 188 64.8199 188 68V88C188 91.1826 186.736 94.2348 184.485 96.4853C182.235 98.7357 179.183 100 176 100C172.817 100 169.765 98.7357 167.515 96.4853C165.264 94.2348 164 91.1826 164 88V84H116C112.817 84 109.765 82.7357 107.515 80.4853C105.264 78.2348 104 75.1826 104 72V24H28V88C28 91.1826 26.7357 94.2348 24.4853 96.4853C22.2348 98.7357 19.1826 100 16 100C12.8174 100 9.76515 98.7357 7.51472 96.4853C5.26428 94.2348 4 91.1826 4 88ZM128 37V60H151L128 37Z"
                  fill="#999"
                />
              </svg>
            </IconButton>
          </Tooltip>
        </DownloadButton>
      )}
    </>
  );
}

export const PDF = ({ pillars, evaluation }) => {
  const statusColors = {
    1: "#cccccc",
    2: "#d15c56",
    3: "#edce61",
    4: "#52b9d9",
    5: "#4cb56f",
    6: "#333333",
  };

  // IMAGES NOT WORKING
  return (
    <Document>
      <Page size="Letter" style={styles.page}>
        <View style={styles.header}>
          <View style={styles.headerStatus}>
            <View
              style={{
                ...styles.headerStatusBar,
                backgroundColor: statusColors[evaluation.evaluationStatus.id],
              }}
            />
            <Text
              style={{
                ...styles.headerStatusText,
                color: statusColors[evaluation.evaluationStatus.id],
              }}
            >
              {evaluation.evaluationStatus.description}
            </Text>
          </View>

          <View style={styles.headerLine}>
            {/* <Image
              style={styles.image}
              src={`https://weekly.integrationconsulting.com/Upload/1.1_Professionals/${evaluation.professiona.login}_192_192.png`}
            /> */}
          </View>
          <View style={styles.headerLine}>
            <Text style={styles.headerTitle}>
              {evaluation.professional.name}
            </Text>
          </View>
          <View style={styles.headerLine}>
            <Text style={styles.headerSubTitle}>
              {evaluation.professional?.jobTitle?.name} —{" "}
              {evaluation.practice.name}
            </Text>
          </View>
          <View style={{ ...styles.headerLine, marginBottom: 16 }}>
            <Text style={styles.headerSubTitle}>
              {evaluation.professional.practice}
            </Text>
          </View>
          <View style={{ ...styles.headerLine, marginBottom: 16 }}>
            {evaluation.cycle.idAreaType === 2 && (
              <View style={styles.headerLineItem}>
                <Text>{evaluation.project.clientName}</Text>
                <Text style={styles.headerLineItemTitle}>CLIENT</Text>
              </View>
            )}
          </View>
          <View style={{ ...styles.headerLine, marginBottom: 16 }}>
            {evaluation.cycle.idAreaType === 2 && (
              <View style={styles.headerLineItem}>
                <Text>{evaluation.project.projectCode}</Text>
                <Text style={styles.headerLineItemTitle}>PROJECT</Text>
              </View>
            )}
            <View style={styles.headerLineItem}>
              <Text>
                {evaluation.cycle.period}Q — {evaluation.cycle.year}
              </Text>
              <Text style={styles.headerLineItemTitle}>PERIOD</Text>
            </View>
          </View>

          <View style={{ ...styles.headerLine, marginBottom: 16 }}>
            {evaluation.evaluator && (
              <View style={styles.headerLineItem}>
                <Text style={styles.headerLineItemTitle}>EVALUATOR</Text>
                <Text>{evaluation.evaluator.name}</Text>
              </View>
            )}
            {evaluation.validator && (
              <View style={styles.headerLineItem}>
                <Text style={styles.headerLineItemTitle}>VALIDATOR</Text>
                <Text>
                  {evaluation.validator.name ?? evaluation.coLeader.name}
                </Text>
              </View>
            )}

            {evaluation.partner && (
              <View style={styles.headerLineItem}>
                <Text style={styles.headerLineItemTitle}>PARTNER</Text>
                <Text>{evaluation.partner.name}</Text>
              </View>
            )}
          </View>
          <View style={{ ...styles.headerLine, flexDirection: "column" }}>
            <Text style={styles.totalGrade}>
              {evaluation.totalAverage.toFixed(2)}
            </Text>
            <Text style={styles.headerLineItemTitle}>Total Grade</Text>
          </View>
        </View>

        <View style={styles.summarySession}>
          {pillars.map((pillar) => (
            <View style={styles.summary} key={pillar.id}>
              <Text style={styles.summaryTitle}>{pillar.name}</Text>

              <View style={styles.summaryCompetenceSession}>
                {pillar.competences
                  .filter((x) => x.isActive)
                  .map((competence) => (
                    <View style={styles.summaryCompetence} key={competence.id}>
                      <Text style={styles.summaryCompetenceTitle}>
                        {competence.description}
                      </Text>
                      <Text style={styles.summaryCompetenceGrade}>
                        {(() => {
                          const competenceGrade =
                            evaluation.evaluationCompetences.find(
                              (x) => x.idCompetence === competence.id
                            );

                          if (!competenceGrade) {
                            return "—";
                          }

                          if (competenceGrade.fieldValue === -1) {
                            return "N/A";
                          }

                          return competenceGrade.fieldValue !== undefined
                            ? competenceGrade.fieldValue.toFixed(2)
                            : "—";
                        })()}
                      </Text>
                    </View>
                  ))}
              </View>
            </View>
          ))}
        </View>
      </Page>
      <Page size="Letter" style={{ ...styles.page, paddingTop: 20 }} wrap>
        <View style={styles.body}>
          <Text style={styles.bodyTitle}>OVERALL</Text>

          {evaluation.cycle.idAreaType === 2 && (
            <View style={styles.section}>
              <Text style={styles.sectionTitle}>PROJECT CONTEXT</Text>
              <View style={styles.sectionContent}>
                <Text>{evaluation.projectContext}</Text>
              </View>
            </View>
          )}

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>OVERVIEW</Text>
            <View style={styles.sectionContent}>
              <Text>{evaluation.overview}</Text>
            </View>
          </View>
        </View>
      </Page>

      {![3, 4, 5, 9].includes(evaluation.cycle.idAreaType) && ( // NON SENIORS
        <Page size="Letter" style={{ ...styles.page, paddingTop: 20 }} wrap>
          {pillars.map((pillar) => (
            <View style={styles.body} key={pillar.id} break>
              <Text style={styles.bodyTitle}>{pillar.name}</Text>

              <View style={styles.section}>
                <Text style={styles.sectionTitle}>Strengths</Text>
                <View style={styles.sectionContent}>
                  <Text>
                    {evaluation.evaluationPillars.find(
                      (x) => x.idPillar === pillar.id
                    ) &&
                      evaluation.evaluationPillars.find(
                        (x) => x.idPillar === pillar.id
                      ).fieldStrength}
                  </Text>
                </View>
              </View>

              <View style={styles.section}>
                <Text style={styles.sectionTitle}>Development Points</Text>
                <View style={styles.sectionContent}>
                  <Text>
                    {evaluation.evaluationPillars.find(
                      (x) => x.idPillar === pillar.id
                    ) &&
                      evaluation.evaluationPillars.find(
                        (x) => x.idPillar === pillar.id
                      ).fieldDevelopment}
                  </Text>
                </View>
              </View>

              <View style={styles.sectionCompetences}>
                {pillar.competences
                  .filter((x) => x.isActive)
                  .map((competence) => (
                    <View
                      style={styles.sectionCompetenceGrade}
                      key={competence.id}
                    >
                      <Text style={styles.sectionGradeTitle}>
                        {competence.description}
                      </Text>
                      <Text style={styles.sectionGradeText}>
                        {evaluation.evaluationCompetences.find(
                          (x) => x.idCompetence === competence.id
                        ) &&
                          (evaluation.evaluationCompetences.find(
                            (x) => x.idCompetence === competence.id
                          ).fieldValue === -1
                            ? "N/A"
                            : evaluation.evaluationCompetences.find(
                                (x) => x.idCompetence === competence.id
                              ).fieldValue)}
                      </Text>
                    </View>
                  ))}
              </View>
            </View>
          ))}
        </Page>
      )}

      {[3, 4, 5, 9].includes(evaluation.cycle.idAreaType) && ( // SENIORS
        <Page size="Letter" style={{ ...styles.page, padding: 20 }} wrap>
          {pillars.map((pillar) => (
            <View style={styles.summary} key={pillar.id}>
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Text style={styles.summaryTitle}>{pillar.name}</Text>
                <Text style={styles.summaryTitle}>
                  {evaluation.evaluationPillars.find(
                    (x) => x.idPillar === pillar.id
                  ) &&
                    (evaluation.evaluationPillars.find(
                      (x) => x.idPillar === pillar.id
                    ).fieldValue === -1
                      ? "N/A"
                      : evaluation.evaluationPillars
                          .find((x) => x.idPillar === pillar.id)
                          .fieldValue.toFixed(2))}
                </Text>
              </View>
              <View style={styles.summaryCompetenceSession}>
                {pillar.competences
                  .filter((x) => x.isActive)
                  .map((competence) => (
                    <View
                      style={styles.summaryCompetenceSeniors}
                      key={competence.id}
                    >
                      <View
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                        }}
                      >
                        <Text style={styles.summaryCompetenceTitle}>
                          {competence.description}
                        </Text>
                        <Text style={styles.summaryCompetenceGrade}>
                          {evaluation.evaluationCompetences.find(
                            (x) => x.idCompetence === competence.id
                          ) &&
                            (evaluation.evaluationCompetences.find(
                              (x) => x.idCompetence === competence.id
                            ).fieldValue === -1
                              ? "N/A"
                              : evaluation.evaluationCompetences
                                  .find((x) => x.idCompetence === competence.id)
                                  .fieldValue.toFixed(2))}
                        </Text>
                      </View>
                      {competence.competenceSeniors
                        .filter((x) => x.isActive)
                        .map((compSenior) => (
                          <View
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              marginLeft: 15,
                              marginBottom: 2,
                            }}
                            key={compSenior.id}
                          >
                            <View
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                              }}
                            >
                              <Text
                                style={{
                                  ...styles.summaryCompetenceTitle,
                                  fontSize: 8,
                                }}
                              >
                                {compSenior.description}
                              </Text>
                              <Text
                                style={{
                                  ...styles.summaryCompetenceGrade,
                                  fontSize: 8,
                                }}
                              >
                                {evaluation.evaluationCompetenceSeniors.find(
                                  (x) => x.idCompetenceSenior === compSenior.id
                                ) &&
                                  (evaluation.evaluationCompetenceSeniors.find(
                                    (x) =>
                                      x.idCompetenceSenior === compSenior.id
                                  ).fieldValue === -1
                                    ? "N/A"
                                    : evaluation.evaluationCompetenceSeniors.find(
                                        (x) =>
                                          x.idCompetenceSenior === compSenior.id
                                      ).fieldValue)}
                              </Text>
                            </View>
                            {evaluation.evaluationCompetenceSeniors.find(
                              (x) => x.idCompetenceSenior === compSenior.id
                            ) &&
                              evaluation.evaluationCompetenceSeniors.find(
                                (x) => x.idCompetenceSenior === compSenior.id
                              ).fieldText !== undefined &&
                              evaluation.evaluationCompetenceSeniors.find(
                                (x) => x.idCompetenceSenior === compSenior.id
                              ).fieldText !== "" && (
                                <View
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    marginBottom: 3,
                                  }}
                                >
                                  <Text
                                    style={{
                                      ...styles.summaryCompetenceTitle,
                                      fontSize: 8,
                                    }}
                                  >
                                    Key Message
                                  </Text>
                                  <Text
                                    style={{
                                      ...styles.summaryCompetenceGrade,
                                      fontSize: 8,
                                      width: "70%",
                                    }}
                                  >
                                    {
                                      evaluation.evaluationCompetenceSeniors.find(
                                        (x) =>
                                          x.idCompetenceSenior === compSenior.id
                                      ).fieldText
                                    }
                                  </Text>
                                </View>
                              )}
                          </View>
                        ))}
                    </View>
                  ))}
              </View>
            </View>
          ))}
        </Page>
      )}

      <Page size="Letter" style={{ ...styles.page, paddingTop: 20 }}>
        <View style={styles.body}>
          <Text style={styles.bodyTitle}>
            Were the points in this evaluation already clear and were they
            discussed in a DNA or through online feedback?
          </Text>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>
              {evaluation.evaluationFeedback?.alreadyClear === true
                ? "Yes"
                : evaluation.evaluationFeedback?.alreadyClear === false
                ? "No"
                : ""}
            </Text>
            <View style={styles.sectionContent}>
              <Text>{evaluation.evaluationFeedback?.alreadyClearText}</Text>
            </View>
          </View>
        </View>
        <View style={styles.body}>
          <Text style={styles.bodyTitle}>
            Do I agree with the points and intensity that were included in the
            evaluation?
          </Text>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>
              {evaluation.evaluationFeedback?.agreeWithPoints === true
                ? "Yes"
                : evaluation.evaluationFeedback?.agreeWithPoints === false
                ? "No"
                : ""}
            </Text>
            <View style={styles.sectionContent}>
              <Text>{evaluation.evaluationFeedback?.agreeWithPointsText}</Text>
            </View>
          </View>
        </View>
        <View style={styles.body}>
          <Text style={styles.bodyTitle}>
            Do you think your evaluation reflects the competence matrix for your
            level?
          </Text>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>
              {evaluation.evaluationFeedback?.evaluationReflects === true
                ? "Yes"
                : evaluation.evaluationFeedback?.evaluationReflects === false
                ? "No"
                : ""}
            </Text>
            <View style={styles.sectionContent}>
              <Text>
                {evaluation.evaluationFeedback?.evaluationReflectsText}
              </Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};
